export function meetTheTeamValidation(field) {
    
    const errors = {
        headerSection: {
            section: {},
            pageTitle:""
        },
        bottomSection: {
            section: {},
            pageTitle:""
        },
        teamSection: {
            members: [],
            pageTitle:""
        },
        metaProperties:{
            title:"",
            description:""
        },
        faq: {
            section: [],
        },
    };
    // Example validation rules:
    if(field?.headerSection?.status) {

        if (!field?.headerSection?.pageTitle?.trim()) {
            errors.headerSection.pageTitle = "Title is required";
        }
    
    
        if (!field?.headerSection?.section?.description?.trim()) {
            errors.headerSection.section.description = "Description is required";
        }
        if (!field?.headerSection?.section?.cta) {
            errors.headerSection.section.cta = "CTA is required";
        }
        if (!field?.headerSection?.section?.url) {
            errors.headerSection.section.url = "CTA Link is required";
        }
    
        if (field?.headerSection?.section?.url && !validURL(field?.headerSection?.section?.url)) {
            errors.headerSection.section.url = "Invalid link: must start with http:// or https://";
        }
        // if (!field?.headerSection?.section?.imageUrl) {
        //     errors.headerSection.section.imageUrl = "Image is required";
        // }
    }
    // bottom section
    if(field?.bottomSection?.status) {
        if (!field?.bottomSection?.pageTitle?.trim()) {
            errors.bottomSection.pageTitle = "Title is required";
        }
        if (!field?.bottomSection?.section?.description?.trim()) {
            errors.bottomSection.section.description = "Description is required";
        }
        // if (!field?.bottomSection?.section?.title?.trim()) {
        //     errors.bottomSection.section.title = "Title is required";
        // }
        // if (!field?.bottomSection?.section?.imageUrl) {
        //     errors.bottomSection.section.imageUrl = "Image is required";
        // }
    
        if (!field?.bottomSection?.section?.cta) {
            errors.bottomSection.section.cta = "CTA is required";
        }
        if (!field?.bottomSection?.section?.url) {
            errors.bottomSection.section.url = "CTA Link is required";
        }
        if (field?.bottomSection?.section?.url && !validURL(field?.bottomSection?.section?.url )) {
            errors.bottomSection.section.url = "Invalid link: must start with http:// or https://";
        }
    }
    if (!field?.metaProperties?.title?.trim()) {
        errors.metaProperties.title = "Meta Title is required";
    }

    if (!field?.metaProperties?.description?.trim()) {
        errors.metaProperties.description = "Meta Description is required";
    }
    if (field?.faq?.status) {
        if (field?.faq?.section?.length > 0) {
            field.faq.section.forEach((banner, index) => {
                const bannerErrors = {};
                // Check for description
                if (!banner.question?.trim()) {
                    bannerErrors.question = "question is required";
                }
                if (!banner.answer?.trim()) {
                    bannerErrors.answer = "answer is required";
                }

                // Add banner-level errors to the topicSection errors array
                if (Object.keys(bannerErrors).length > 0) {
                    errors.faq.section[index] = bannerErrors;
                }
            });


        }
    }

    if(field?.teamSection?.status){
        if (!field?.teamSection?.pageTitle?.trim()) {
            errors.teamSection.pageTitle = "Title is required";
        }
        if (field?.teamSection?.members?.length > 0) {
            field.teamSection.members.forEach((banner, index) => {
                const bannerErrors = {};
    
                // Check for title
                if (!banner.name?.trim()) {
                    bannerErrors.name = "Name is required";
                }
                // Check for title
                if (!banner.role?.trim()) {
                    bannerErrors.role = "Role is required";
                }
    
                // Check for description
                if (!banner.description?.trim()) {
                    bannerErrors.description = "Description is required";
                }else if (banner.description.length > 600) {
                    bannerErrors.description = "Character limit exceeded.";
                }
    
    
                // Check for imageUrl
                if (!banner.image || !banner.image.url?.trim()) {
                    bannerErrors.image = {
                        ...(bannerErrors.image || {}), // Ensure image object exists
                        url: "Image  is required",
                    };
                }
    
                // Add banner-level errors to the teamSection errors array
                if (Object.keys(bannerErrors).length > 0) {
                    errors.teamSection.members[index] = bannerErrors;
                }
            });
    
            // **Validate platformAvailability - At least one should be true**
            if (!Object.values(field?.platformAvailability || {}).includes(true)) {
                errors.platformAvailability = "At least one platform must be selected.";
            }
    
            // **Validate displaySettings - At least one should be true**
            if (!Object.values(field?.displaySettings || {}).includes(true)) {
                errors.displaySettings = "At least one display option must be selected.";
            }
    
        }
    }

    return {
        errors,
        isValid:
            Object.keys(errors.headerSection.section).length === 0 &&
            Object.keys(errors.bottomSection.section).length === 0 &&
            Object.keys(errors.metaProperties).length === 0 && 
            Object.keys(errors.teamSection.members).every(
                (key) => Object.keys(errors.teamSection.members[key]).length === 0
            ) &&
            Object.keys(errors.faq.section).every(
                (key) => Object.keys(errors.faq.section[key]).length === 0
            ) &&
            errors.platformAvailability === "" &&
            errors.displaySettings === "",
    };
}

// export const validURL = (url) => {
//     const urlPattern = /^(https?:\/\/)([\w.-]+)\.([a-z]{2,6})([/\w .-]*)*\/?$/i;
//     return urlPattern.test(url);
// };
export const validURL = (url) => {
    const urlPattern = new RegExp(
      '^(https?:\\/\\/)?' +                    // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,})' + // domain name
      '(\\:\\d+)?' +                           // port
      '(\\/[-a-z\\d%@_.~+&:]*)*' +             // path
      '(\\?[;&a-z\\d%@_.,~+&:=-]*)?' +         // query string
      '(\\#[-a-z\\d_]*)?$',                    // fragment
      'i'
    );
    return !!urlPattern.test(url);
  };